import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const apiKey = "K3nJM-dO3buR6QNxXZHSpg";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    ns: ["default"],
    defaultNS: "default",

    supportedLngs: ["en","ar"],

    backend: {
      loadPath: loadPath
    },

    // Don't block the whole app behind <Suspense> while remote translations load.
    // Without this, the empty Suspense fallback shows a blank screen on first load
    // (forcing a manual refresh once translations are cached). Render immediately
    // and let text update when translations arrive.
    react: {
      useSuspense: false
    }
  })